import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Administration/designations/form'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_edit_designation } from '../../../actions/v3/designation'
const Add = (props) => {

    const location = useLocation();
    const { userData, page } = location.state || {};
    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(userData))['ROLE_NAME']
        v3_edit_designation(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listDesignation.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });

            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Edit Designation'}>
                <Form
                    // title={'Edit Designation'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(userData))}
                    buttonName={'Save Designation'}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add